import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./ConciliationList.scss"
import messages from "../../assets/i18n";
import ItemList from '../../containers/ItemList/ItemList'
import { ButtonStandard, ConciliationFilter } from "../../components";

function ConciliationList(props) {

	const dispatch = useDispatch();

	const lang = useSelector(state => state.language.name);
    const filters = useSelector(state => state.conciliationResult.filter);

	const conciliationList = useSelector(state => state.conciliationResult.conciliationList);
    const isLoadingList    = useSelector(state => state.conciliationResult.isLoadingConciliationList);
    const page             = useSelector(state => state.conciliationResult.conciliationListPage);
    const hasMore          = useSelector(state => state.conciliationResult.conciliationListHasMore);
        
    const [isTableEmpty, setIsTableEmpty] = useState(false)

	const pageMessages = messages[lang].conciliationListPage;
	const titleTable   = messages[lang].conciliations;
    const titlePage    = messages[lang].conciliationListPage.inquiry;

	const header = [
		pageMessages.pedido,
		pageMessages.fornecedor,
		pageMessages.dataConciliacao,
        pageMessages.ultimoMotivoReprovacao,
        pageMessages.statusComercial,
        pageMessages.statusRFM,
        pageMessages.numeroConciliacao,
        pageMessages.numeroSerieNF,
	];

    useEffect(() => {
		dispatch({
			type: 'GET_CONCILIATION_LIST',
            page: page,
            filter: filters
		})
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {
		if (conciliationList.length > 0) {
			setIsTableEmpty(false)
		} else {
            setIsTableEmpty(true)
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [conciliationList]);

    const handleHasMore = () => {
		dispatch({
			type: 'GET_CONCILIATION_LIST',
			page: page,
			filter: filters
		})
	}

	const mappedConciliationList = () => {
		return conciliationList.map((item) => {
			return [
					item.pedido,
                    { 
                        text: item.nomeFornecedor,
                        maxLength: 4000
                    },
                    item.dataConciliacao
                        ?                  
                        {
                            text: item.dataConciliacao,
                            type: 'datehour',
                        }
                        :
                        '--/--/----',
                    { 
                        text: item.motivoReprovacao,
                        maxLength: 4000
                    },
                    item.statusComercial,
                    item.statusRFM,
                    item.conciliacao,
                    item.notaFiscal + " " + item.serieNotaFiscal,
				]

		});
	}

    const getConciliations = () => {
        dispatch({
			type: 'GET_CONCILIATION_LIST',
            page: 1,
            filter: filters,
            cleanTable: true
		})
	}

	return (
		<div className="conciliation-list-page">          
            <Container className="pt-3 justify-content-start">
                <Row className="justify-content-between">
                    <Col className="d-flex align-items-center justify-content-start">
                        <span className="text-3 font-weight-bold header-main pl-2">{titlePage}</span>
                    </Col>
                </Row>
                <ConciliationFilter />
            </Container>

            <Container className="px-4 d-flex justify-content-end">
				<ButtonStandard
					text={messages[lang].searchConciliation}
					textClass="text-1"
					className="btn-sm btn-outline-success btn-standard px-2 mr-2"
					onClick={() => getConciliations()}/>
			</Container>

            <Container className="pt-3 justify-content-start">
                <Container className="mt-1 pt-1 mb-4 pb-5">
                    <ItemList
                        header={header}
                        titleTable={titleTable}
                        listTable={mappedConciliationList()}
                        isLoading={isLoadingList && conciliationList.length === 0 ? true : false}
                        isEmpty={isTableEmpty}
                        hasMore={hasMore}
                        handleHasMore={handleHasMore}
                        hasMoreIsLoading={isLoadingList}
                        />
                </Container>
            </Container>            
		</div>
	)
}

export default withRouter(ConciliationList);